const config = {};

config.apiUrl = process.env.VUE_APP_API_URL;
config.socketUrl = process.env.VUE_APP_SOCKET_URL;

export default config;
